angular.module('dpw.services')
    .factory('developerEventsService', ['$q', 'api', function ($q, api) {
        return {
            /**
             * @description Un-wrap values from language like "en-US".
             * @param {object} event
             */
            formatEvent: function (event) {
                var formatted = {};
                var now = moment();

                _.forEach(event, function (languages, key) {
                    formatted[key] = languages['en-US'];
                });

                var eventEndDate = moment(formatted.endDate);

                if (eventEndDate.isBefore(now)) {
                    formatted.isPostEvent = true;
                }

                return formatted;
            },

            formatEvents: function (events) {
                var self = this;
                return events.map(function (event, index) {
                    var formattedEvent = self.formatEvent(event);
                    formattedEvent._index = index;
                    formattedEvent.isOneDayEvent = moment(formattedEvent.startDate)
                        .isSame(moment(formattedEvent.endDate), 'day');
                    return formattedEvent;
                });
            },

            getFeaturedEvents: function () {
                var self = this;
                return $q(function (resolve, reject) {
                    self.getEvents(api.support.developerEvents.getFeaturedEvents)
                        .then(function (res) {
                            resolve(self.formatEvents(res.events || []));
                        })
                        .catch(function () {
                            reject();
                        });
                });
            },

            getAllEvents: function (apiOptions) {
                var self = this;
                return $q(function (resolve, reject) {
                    self.getEvents(api.support.developerEvents.getAllEvents, apiOptions)
                        .then(function (res) {
                            resolve(self.formatEvents(res.events || []));
                        })
                        .catch(function () {
                            reject();
                        });
                });
            },

            getEvents: function (request, apiOptions) {
                apiOptions = apiOptions || {};
                return api.call(request(apiOptions), angular.noop, angular.noop);
            },

            getAllEventsReferToDate: function (events, referDate) {
                var hasEventForSelectedDate = false;
                var selectedDate = moment(referDate);

                events.forEach(function (event) {
                    var eventStartDate = moment(event.startDate);

                    if (eventStartDate.isSame(selectedDate, 'day')) {
                        hasEventForSelectedDate = true;
                        event.highlight = true;
                    } else {
                        event.highlight = false;
                    }
                });

                events = events.filter(function (event) {
                    return !(event.isPadding && !moment(event.startDate).isSame(selectedDate, 'day'));
                });

                if (!hasEventForSelectedDate) {
                    events.push({
                        startDate: selectedDate.format(),
                        highlight: true,
                        isPadding: true
                    });
                }

                return this.orderByChronological(events);
            },

            getFirstHighlightEventIndex: function (events) {
                var found = 0;

                events.forEach(function (event) {
                    if (event.highlight) {
                        found = event._index;
                    }
                });

                return found;
            },

            getMonths: function (start, diff) {
                var format = 'YYYY-MM';
                var result = [];
                var month;

                for (var i = 0; i <= diff; i++) {
                    month = moment(start, format).add(i, 'month').set('date', 1);
                    result.push({
                        label: month.format('MMM YYYY'),
                        value: month
                    });
                }

                return result;
            },

            orderByChronological: function(events) {
                return events.sort(function (a, b) {
                    var dateA = moment(a.startDate);
                    var dataB = moment(b.startDate);
                    return dateA.diff(dataB);
                }).map(function (event, index) {
                    event._index = index;
                    return event;
                });
            }
        };
    }]);
